import { lazy } from "react";
import { ArrowRightLeft } from "lucide-react";
import { defineWebModule } from "../../web/module";
import { showAssetWater, showGrazing, showHayWork, showLocation, showRain } from "./web/sections";
import "./web/land.css";

// Pages load when opened, so the app starts fast on a phone with weak signal.
const AssetWaterSection = lazy(() => import("./web/sections").then((m) => ({ default: m.AssetWaterSection })));
const GrazingSection = lazy(() => import("./web/sections").then((m) => ({ default: m.GrazingSection })));
const HayWorkSection = lazy(() => import("./web/sections").then((m) => ({ default: m.HayWorkSection })));
const LocationSection = lazy(() => import("./web/sections").then((m) => ({ default: m.LocationSection })));
const RainSection = lazy(() => import("./web/sections").then((m) => ({ default: m.RainSection })));
const FieldWorkForm = lazy(() => import("./web/forms").then((m) => ({ default: m.FieldWorkForm })));
const GrazingWorkspace = lazy(() => import("./web/GrazingWorkspace").then((m) => ({ default: m.GrazingWorkspace })));
const HarvestForm = lazy(() => import("./web/forms").then((m) => ({ default: m.HarvestForm })));
const LandSettings = lazy(() => import("./web/sections").then((m) => ({ default: m.LandSettings })));
const MoveDetail = lazy(() => import("./web/sections").then((m) => ({ default: m.MoveDetail })));
const MoveForm = lazy(() => import("./web/MoveForm").then((m) => ({ default: m.MoveForm })));
const PlanJob = lazy(() => import("./web/PlanJob").then((m) => ({ default: m.PlanJob })));
const RainForm = lazy(() => import("./web/forms").then((m) => ({ default: m.RainForm })));
const RanchMap = lazy(() => import("./web/RanchMap").then((m) => ({ default: m.RanchMap })));
const WaterForm = lazy(() => import("./web/forms").then((m) => ({ default: m.WaterForm })));

export default defineWebModule({
  id: "land",
  icons: { move: ArrowRightLeft },
  events: {
    "land.move": { Form: MoveForm, Detail: MoveDetail },
    "land.rainfall": { Form: RainForm },
    "land.hay_harvest": { Form: HarvestForm },
    "land.field_work": { Form: FieldWorkForm },
    "land.water_check": { Form: WaterForm },
  },
  animalSections: [{ id: "location", label: "Where it's been", order: 70, show: showLocation, Component: LocationSection }],
  animalActions: [{
    id: "move", label: "Move", icon: "move", eventType: "land.move", priority: 40,
    when: (a) => a.status === "active" || a.status === "missing",
    subjects: (a) => [{ kind: "animal", id: a.id, role: "animal", label: a.label }, ...(a.location ? [{ kind: "place" as const, id: a.location.id, role: "from", label: a.location.label }] : [])],
  }],
  workspaces: { grazing: GrazingWorkspace },
  ranchSections: { map: RanchMap },
  jobs: { "land.grazing_plan": PlanJob },
  placeSections: [
    { id: "grazing", label: "Grazing", order: 10, show: showGrazing, Component: GrazingSection },
    { id: "rain", label: "Rain", order: 20, show: showRain, Component: RainSection },
    { id: "hay", label: "Hay and field work", order: 30, show: showHayWork, Component: HayWorkSection },
  ],
  assetSections: [{ id: "water", label: "Water", order: 20, show: showAssetWater, Component: AssetWaterSection }],
  Settings: LandSettings,
});
